import { render, staticRenderFns } from "./BimUploadDialog.vue?vue&type=template&id=4d5f785b"
import script from "./BimUploadDialog.vue?vue&type=script&lang=js"
export * from "./BimUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./BimUploadDialog.vue?vue&type=style&index=0&id=4d5f785b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports